/**
 * The buggy marker, drawn to a canvas at load time.
 *
 * Drawn rather than shipped as a file so it stays crisp at any density and adds
 * nothing to the bundle. Top-down, because the map is top-down, and shaped so
 * the front is unmistakable — the whole point of the icon is telling you which
 * way you are pointing, and a symmetrical blob does not do that.
 */
const SIZE = 96; // device pixels; MapLibre scales it down

export function buggyIcon(): ImageData {
  const c = document.createElement('canvas');
  c.width = c.height = SIZE;
  const g = c.getContext('2d')!;
  g.clearRect(0, 0, SIZE, SIZE);

  const cx = SIZE / 2;

  // Soft halo so the marker survives being over pale sand or bright fairway.
  g.beginPath();
  g.arc(cx, cx, 44, 0, Math.PI * 2);
  g.fillStyle = 'rgba(11,18,13,0.32)';
  g.fill();

  g.save();
  g.translate(cx, cx);

  const roundRect = (x: number, y: number, w: number, h: number, r: number) => {
    g.beginPath();
    g.moveTo(x + r, y);
    g.arcTo(x + w, y, x + w, y + h, r);
    g.arcTo(x + w, y + h, x, y + h, r);
    g.arcTo(x, y + h, x, y, r);
    g.arcTo(x, y, x + w, y, r);
    g.closePath();
  };

  // Wheels first, so the body sits over them.
  g.fillStyle = '#0d1712';
  for (const [wx, wy] of [
    [-19, -20],
    [13, -20],
    [-19, 10],
    [13, 10],
  ]) {
    roundRect(wx, wy, 6, 11, 2);
    g.fill();
  }

  // Body.
  roundRect(-15, -26, 30, 50, 7);
  g.fillStyle = '#f4f8f5';
  g.fill();
  g.lineWidth = 3;
  g.strokeStyle = '#1f7a3f';
  g.stroke();

  // Canopy, offset forward so the silhouette is asymmetric at a glance.
  roundRect(-11, -18, 22, 24, 4);
  g.fillStyle = '#cfe0d5';
  g.fill();

  // Nose: a wedge pointing the way the buggy faces. This is the load-bearing
  // part of the whole icon.
  g.beginPath();
  g.moveTo(0, -34);
  g.lineTo(9, -24);
  g.lineTo(-9, -24);
  g.closePath();
  g.fillStyle = '#38e07b';
  g.fill();

  g.restore();

  return g.getImageData(0, 0, SIZE, SIZE);
}

export const BUGGY_ICON_ID = 'buggy-marker';
export const BUGGY_ICON_SIZE = SIZE;
